export default class LibraryValidationRule {
  public readonly MIN_PRICE = 1
  public readonly MIN_PRICE_MESSAGE = 'Paid public library must have a price'

  public PriceRules: Array<object> = [(v: number) => (!!v && v >= this.MIN_PRICE) || this.MIN_PRICE_MESSAGE]

  constructor() {}
}
